"use client"

import { HeroCarouselSlideDto } from "api"
import NextLink from "common/bit/NextLink"
import { trackHeroBannerCtaClick } from "utils/gtm"
import { CtaPrimary, CtaRow, CtaSecondary } from "./hero.styled"
import { isInternalUrl, showCtaRow } from "./heroHelpers"

type Props = { slide: HeroCarouselSlideDto }

const HeroCtaRow = ({ slide }: Props) => {
  if (!showCtaRow(slide)) return null
  return (
    <CtaRow>
      {slide.ctaPrimaryActive && slide.ctaPrimaryText && (
        <CtaPrimary
          disableRipple
          component={isInternalUrl(slide.ctaPrimaryUrl) ? NextLink : "a"}
          href={slide.ctaPrimaryUrl}
          onClick={() => trackHeroBannerCtaClick(slide.ctaPrimaryText)}
        >
          {slide.ctaPrimaryText}
        </CtaPrimary>
      )}
      {slide.ctaSecondaryActive && slide.ctaSecondaryText && (
        <CtaSecondary
          disableRipple
          component={isInternalUrl(slide.ctaSecondaryUrl) ? NextLink : "a"}
          href={slide.ctaSecondaryUrl}
          onClick={() => trackHeroBannerCtaClick(slide.ctaSecondaryText)}
        >
          {slide.ctaSecondaryText}
        </CtaSecondary>
      )}
    </CtaRow>
  )
}

export default HeroCtaRow
